import { RootState } from "@app/redux/root-reducer";

export const selectSellCarState = (store : RootState) => store.sellCarReducer.sellCar;